<template>
  <div class="flex h-screen">
    <div class="m-auto">
      <img
        class="w-84"
        src="../assets/img/logo.png"
        alt="Logo Koehler"
      >
      <img
        class="m-auto mt-8 w-1/6"
        src="../assets/svg/three-dots.svg"
        alt="Loader"
      >
    </div>
    <div class="absolute h-56 w-full bottom-0">
      <p class="font-sans text-xl font-hairline text-center">
        Developed by <b class="font-medium">InterConnecta</b>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingScreen",
};
</script>